import React, { useState } from 'react';

/* ── Service icons ── */
const IcoDashboard = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="1" />
    <path d="M3 9h18M9 3v18" />
    <path d="M13 13h5M13 17h3" />
  </svg>
);
const IcoLink = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10 14a5 5 0 007 0l3-3a5 5 0 00-7-7l-1 1" />
    <path d="M14 10a5 5 0 00-7 0l-3 3a5 5 0 007 7l1-1" />
  </svg>
);
const IcoCog = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3" />
    <path d="M12 1v4M12 19v4M4.2 4.2l2.8 2.8M17 17l2.8 2.8M1 12h4M19 12h4M4.2 19.8L7 17M17 7l2.8-2.8" />
  </svg>
);
const IcoAI = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2l2 5 5 2-5 2-2 5-2-5-5-2 5-2 2-5z" />
    <circle cx="18" cy="18" r="2" />
  </svg>
);
const IcoMobile = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <rect x="6" y="2" width="12" height="20" rx="2" />
    <path d="M10 5h4" />
    <circle cx="12" cy="18" r=".8" fill="currentColor" />
  </svg>
);
const IcoShield = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2l9 4v6c0 5-4 9-9 10-5-1-9-5-9-10V6l9-4z" />
    <path d="M9 12l2 2 4-4" />
  </svg>
);

/* ── Mini mockup: CRM Hub ── */
const MiniCRMMockup: React.FC = () => (
  <div style={{
    background: 'var(--white)',
    border: '1px solid var(--border)',
    borderRadius: '4px',
    padding: '.8rem',
    fontFamily: "'Montserrat', sans-serif",
  }}>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '.5rem' }}>
      <div style={{ fontSize: '.55rem', fontWeight: 700, color: 'var(--ink)' }}>Hub CRM</div>
      <div style={{ fontSize: '.45rem', color: '#2E7D32', fontWeight: 600 }}>● 4 sync</div>
    </div>
    <div style={{ position: 'relative', height: '90px', background: 'var(--blue-pale)', borderRadius: '3px', overflow: 'hidden' }}>
      <svg viewBox="0 0 200 90" style={{ width: '100%', height: '100%', position: 'absolute', inset: 0 }}>
        {/* Lines from logos to center */}
        <line x1="25" y1="20" x2="100" y2="45" stroke="var(--blue)" strokeOpacity=".3" strokeWidth="1" strokeDasharray="2 2" />
        <line x1="175" y1="20" x2="100" y2="45" stroke="var(--blue)" strokeOpacity=".3" strokeWidth="1" strokeDasharray="2 2" />
        <line x1="25" y1="70" x2="100" y2="45" stroke="var(--blue)" strokeOpacity=".3" strokeWidth="1" strokeDasharray="2 2" />
        <line x1="175" y1="70" x2="100" y2="45" stroke="var(--blue)" strokeOpacity=".3" strokeWidth="1" strokeDasharray="2 2" />
        {/* Animated dots */}
        <circle r="2" fill="var(--gold)"><animateMotion dur="2s" repeatCount="indefinite" path="M 25 20 L 100 45" /></circle>
        <circle r="2" fill="var(--gold)"><animateMotion dur="2.4s" repeatCount="indefinite" path="M 175 20 L 100 45" /></circle>
        <circle r="2" fill="var(--gold)"><animateMotion dur="2.8s" repeatCount="indefinite" path="M 25 70 L 100 45" /></circle>
        <circle r="2" fill="var(--gold)"><animateMotion dur="2.2s" repeatCount="indefinite" path="M 175 70 L 100 45" /></circle>
        {/* Central hub */}
        <circle cx="100" cy="45" r="14" fill="var(--blue)" />
        <circle cx="100" cy="45" r="18" fill="none" stroke="var(--blue)" strokeOpacity=".25">
          <animate attributeName="r" values="18;24;18" dur="2.4s" repeatCount="indefinite" />
          <animate attributeName="opacity" values=".4;0;.4" dur="2.4s" repeatCount="indefinite" />
        </circle>
        <text x="100" y="48" textAnchor="middle" fill="white" fontFamily="'Cormorant Garamond', serif" fontSize="10" fontWeight="600">M</text>
      </svg>
      {/* CRM badges */}
      {[
        { label: 'SF', color: '#00A1E0', x: 5, y: 10 },
        { label: 'HS', color: '#FF7A59', x: 155, y: 10 },
        { label: 'ZH', color: '#E42527', x: 5, y: 60 },
        { label: 'OD', color: '#714B67', x: 155, y: 60 },
      ].map((b) => (
        <div key={b.label} style={{
          position: 'absolute', left: `${b.x}px`, top: `${b.y}px`,
          width: '40px', height: '22px',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: 'var(--white)', border: `1.2px solid ${b.color}`,
          borderRadius: '3px', fontSize: '.48rem', fontWeight: 700, color: b.color,
        }}>{b.label}</div>
      ))}
    </div>
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px', marginTop: '.4rem' }}>
      <div style={{ background: 'var(--blue-pale)', padding: '.25rem .4rem', borderRadius: '2px', fontSize: '.45rem' }}>
        <span style={{ color: 'var(--ink2)' }}>Contacts</span> <strong style={{ color: 'var(--blue)' }}>12 847</strong>
      </div>
      <div style={{ background: 'var(--blue-pale)', padding: '.25rem .4rem', borderRadius: '2px', fontSize: '.45rem' }}>
        <span style={{ color: 'var(--ink2)' }}>Deals</span> <strong style={{ color: 'var(--blue)' }}>438</strong>
      </div>
    </div>
  </div>
);

/* ── Mini mockup: Workflow automation ── */
const MiniWorkflowMockup: React.FC = () => (
  <div style={{
    background: 'var(--white)',
    border: '1px solid var(--border)',
    borderRadius: '4px',
    padding: '.8rem',
    fontFamily: "'Montserrat', sans-serif",
  }}>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '.5rem' }}>
      <div style={{ fontSize: '.55rem', fontWeight: 700, color: 'var(--ink)' }}>Workflow actif</div>
      <div style={{ padding: '.1rem .3rem', background: 'rgba(184,146,42,.14)', color: 'var(--gold-dark)', fontSize: '.42rem', fontWeight: 700, letterSpacing: '.08em', borderRadius: '2px' }}>▶ RUN</div>
    </div>
    {/* Node canvas */}
    <div style={{
      position: 'relative',
      height: '90px',
      background: 'var(--cream2)',
      borderRadius: '3px',
      backgroundImage: 'radial-gradient(circle, rgba(26,111,168,.15) 1px, transparent 1px)',
      backgroundSize: '10px 10px',
      overflow: 'hidden',
    }}>
      <svg viewBox="0 0 200 90" preserveAspectRatio="none" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%' }}>
        <path d="M 30 25 L 75 25 L 95 45 L 135 45" stroke="var(--blue)" strokeWidth="1.2" fill="none" strokeDasharray="3 2" />
        <path d="M 95 45 L 135 70" stroke="var(--blue)" strokeWidth="1.2" fill="none" strokeDasharray="3 2" />
        <circle r="2.5" fill="var(--gold)">
          <animateMotion dur="2.4s" repeatCount="indefinite" path="M 30 25 L 75 25 L 95 45 L 135 45" />
        </circle>
      </svg>
      {[
        { label: 'Trigger', color: '#2E7D32', x: '5%', y: '16%', icon: '▶' },
        { label: 'Check', color: 'var(--gold-dark)', x: '36%', y: '42%', icon: '◆' },
        { label: 'CRM', color: 'var(--blue)', x: '68%', y: '42%', icon: '→' },
        { label: 'Slack', color: '#5E35B1', x: '68%', y: '70%', icon: '✉' },
      ].map((n) => (
        <div key={n.label} style={{
          position: 'absolute', left: n.x, top: n.y,
          display: 'flex', alignItems: 'center', gap: '3px',
          padding: '.12rem .3rem',
          background: 'var(--white)', border: `1px solid ${n.color}`,
          borderRadius: '3px', fontSize: '.42rem', fontWeight: 600, color: 'var(--ink)',
        }}>
          <span style={{
            width: '8px', height: '8px', background: n.color, color: '#fff',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            borderRadius: '1.5px', fontSize: '.35rem',
          }}>{n.icon}</span>
          {n.label}
        </div>
      ))}
    </div>
    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '.35rem', fontSize: '.45rem', color: 'var(--ink2)' }}>
      <span>4 étapes · 1.2s/exec</span>
      <span style={{ color: '#2E7D32', fontWeight: 600 }}>● 1 247/j</span>
    </div>
  </div>
);

/* ── Mini mockup: AI Assistant chat ── */
const MiniAIMockup: React.FC = () => (
  <div style={{
    background: 'var(--white)',
    border: '1px solid var(--border)',
    borderRadius: '4px',
    padding: '.8rem',
    fontFamily: "'Montserrat', sans-serif",
  }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: '.4rem', marginBottom: '.5rem' }}>
      <div style={{
        width: '18px', height: '18px',
        background: 'linear-gradient(135deg, var(--blue), #5E35B1)',
        borderRadius: '3px', display: 'flex', alignItems: 'center', justifyContent: 'center',
        color: 'white', fontSize: '.55rem', fontWeight: 700,
      }}>✦</div>
      <div style={{ fontSize: '.55rem', fontWeight: 700, color: 'var(--ink)' }}>Assistant IA</div>
      <div style={{ marginLeft: 'auto', fontSize: '.42rem', color: 'var(--ink2)', padding: '.1rem .3rem', background: 'var(--blue-pale)', borderRadius: '2px', fontWeight: 600 }}>LLM</div>
    </div>

    {/* User bubble */}
    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '.35rem' }}>
      <div style={{ background: 'var(--blue)', color: 'white', padding: '.3rem .5rem', borderRadius: '8px 8px 2px 8px', fontSize: '.48rem', maxWidth: '70%' }}>
        CA au Q3 ?
      </div>
    </div>

    {/* AI bubble */}
    <div style={{ display: 'flex', gap: '.3rem', alignItems: 'flex-start', marginBottom: '.35rem' }}>
      <div style={{
        width: '14px', height: '14px',
        background: 'linear-gradient(135deg, var(--blue), #5E35B1)',
        borderRadius: '2.5px', display: 'flex', alignItems: 'center', justifyContent: 'center',
        color: 'white', fontSize: '.5rem', fontWeight: 700, flexShrink: 0,
      }}>✦</div>
      <div style={{
        background: 'var(--cream)', border: '1px solid var(--border)',
        padding: '.3rem .5rem', borderRadius: '2px 8px 8px 8px',
        fontSize: '.48rem', color: 'var(--ink)', lineHeight: 1.5,
      }}>
        Progression +28% sur le Q3, portée par le segment enterprise
        <span style={{
          display: 'inline-block', width: '1.5px', height: '.55rem',
          background: 'var(--blue)', marginLeft: '1px', verticalAlign: 'middle',
          animation: 'caret 1s steps(2) infinite',
        }} />
      </div>
    </div>

    {/* Sources */}
    <div style={{ display: 'flex', gap: '3px', flexWrap: 'wrap', marginLeft: '18px' }}>
      {[1, 2, 3].map((n) => (
        <div key={n} style={{
          display: 'inline-flex', alignItems: 'center', gap: '2px',
          padding: '.1rem .3rem', background: 'var(--white)', border: '1px solid var(--border)',
          borderRadius: '2px', fontSize: '.4rem', color: 'var(--ink2)',
        }}>
          <span style={{
            background: 'var(--blue-pale)', color: 'var(--blue)',
            width: '8px', height: '8px', borderRadius: '50%', fontSize: '.35rem', fontWeight: 700,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>{n}</span>
          Source
        </div>
      ))}
    </div>
  </div>
);

/* ── Mini mockup: Mobile app ── */
const MiniMobileMockup: React.FC = () => (
  <div style={{
    background: 'linear-gradient(135deg, var(--blue-pale) 0%, var(--white) 100%)',
    border: '1px solid var(--border)',
    borderRadius: '4px',
    padding: '.8rem',
    display: 'flex',
    gap: '.7rem',
    alignItems: 'center',
    fontFamily: "'Montserrat', sans-serif",
  }}>
    {/* Phone frame */}
    <div style={{
      width: '62px',
      height: '110px',
      background: '#0A1929',
      borderRadius: '10px',
      padding: '3px',
      flexShrink: 0,
      boxShadow: '0 6px 18px -4px rgba(15,39,68,.4)',
    }}>
      <div style={{ width: '100%', height: '100%', background: 'var(--white)', borderRadius: '7px', overflow: 'hidden', position: 'relative' }}>
        {/* Notch */}
        <div style={{ position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)', width: '22px', height: '5px', background: '#0A1929', borderBottomLeftRadius: '3px', borderBottomRightRadius: '3px', zIndex: 2 }} />
        {/* App content */}
        <div style={{ padding: '8px 5px 4px' }}>
          {/* Card */}
          <div style={{ background: 'linear-gradient(135deg, #0F2744, var(--blue))', height: '22px', borderRadius: '3px', padding: '3px 4px', marginBottom: '4px' }}>
            <div style={{ width: '60%', height: '2px', background: 'rgba(255,255,255,.4)', borderRadius: '1px', marginBottom: '2px' }} />
            <div style={{ width: '40%', height: '3px', background: 'var(--gold)', borderRadius: '1px' }} />
          </div>
          {/* Rows */}
          {[0, 1, 2].map((i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '3px', marginBottom: '3px' }}>
              <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: i === 0 ? 'var(--gold)' : 'var(--blue-pale)' }} />
              <div style={{ flex: 1 }}>
                <div style={{ width: '100%', height: '2px', background: 'var(--ink)', opacity: .4, borderRadius: '1px', marginBottom: '1px' }} />
                <div style={{ width: '60%', height: '1.5px', background: 'var(--ink2)', opacity: .3, borderRadius: '1px' }} />
              </div>
            </div>
          ))}
          {/* Bottom nav dots */}
          <div style={{ display: 'flex', justifyContent: 'space-around', position: 'absolute', bottom: '4px', left: 0, right: 0 }}>
            <div style={{ width: '4px', height: '4px', borderRadius: '50%', background: 'var(--blue)' }} />
            <div style={{ width: '4px', height: '4px', borderRadius: '50%', background: 'var(--border)' }} />
            <div style={{ width: '4px', height: '4px', borderRadius: '50%', background: 'var(--border)' }} />
          </div>
        </div>
      </div>
    </div>
    {/* Right side: app indicators */}
    <div style={{ flex: 1, minWidth: 0 }}>
      <div style={{ display: 'flex', gap: '4px', marginBottom: '.3rem', flexWrap: 'wrap' }}>
        <div style={{ padding: '.15rem .3rem', background: 'rgba(26,111,168,.12)', color: 'var(--blue)', fontSize: '.42rem', fontWeight: 700, letterSpacing: '.08em', borderRadius: '2px' }}>iOS</div>
        <div style={{ padding: '.15rem .3rem', background: 'rgba(46,125,50,.12)', color: '#2E7D32', fontSize: '.42rem', fontWeight: 700, letterSpacing: '.08em', borderRadius: '2px' }}>ANDROID</div>
      </div>
      <div style={{ fontSize: '.42rem', color: 'var(--ink2)', letterSpacing: '.06em', textTransform: 'uppercase', fontWeight: 600, marginBottom: '.2rem' }}>Build status</div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
        {[
          { label: 'Push notifs', status: 'OK', color: '#2E7D32' },
          { label: 'Auth biométrique', status: 'OK', color: '#2E7D32' },
          { label: 'Offline sync', status: '●●●', color: 'var(--blue)' },
        ].map((r) => (
          <div key={r.label} style={{ display: 'flex', justifyContent: 'space-between', fontSize: '.48rem' }}>
            <span style={{ color: 'var(--ink)' }}>{r.label}</span>
            <span style={{ color: r.color, fontWeight: 700 }}>{r.status}</span>
          </div>
        ))}
      </div>
    </div>
  </div>
);

/* ── Mini mockup: Cybersécurité & Cloud ── */
const MiniCyberMockup: React.FC = () => (
  <div style={{
    background: '#0A1929',
    border: '1px solid rgba(184,146,42,.25)',
    borderRadius: '4px',
    padding: '.8rem',
    fontFamily: "'Montserrat', sans-serif",
    position: 'relative',
    overflow: 'hidden',
  }}>
    {/* Glow corner */}
    <div style={{ position: 'absolute', top: '-20px', right: '-20px', width: '60px', height: '60px', background: 'radial-gradient(circle, rgba(46,125,50,.35), transparent 70%)' }} />

    {/* Header with shield */}
    <div style={{ display: 'flex', alignItems: 'center', gap: '.5rem', marginBottom: '.5rem', position: 'relative' }}>
      <svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="#2E7D32" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M10 2l7 3v5c0 4-3 7-7 8-4-1-7-4-7-8V5l7-3z" />
        <path d="M7 10l2 2 4-4" />
      </svg>
      <div style={{ fontSize: '.55rem', fontWeight: 700, color: '#FFFFFF', letterSpacing: '.02em' }}>Security Dashboard</div>
      <div style={{ marginLeft: 'auto', display: 'inline-flex', alignItems: 'center', gap: '.25rem' }}>
        <span style={{ width: '5px', height: '5px', borderRadius: '50%', background: '#2E7D32', animation: 'servPulse 1.4s ease-in-out infinite' }} />
        <span style={{ fontSize: '.42rem', fontWeight: 700, color: '#4ADE80', letterSpacing: '.1em' }}>SECURE</span>
      </div>
    </div>

    {/* Status rows */}
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginBottom: '.5rem' }}>
      {[
        { label: 'Firewall · Cloud WAF', value: '✓ Actif' },
        { label: 'SSL/TLS · Certificats', value: '✓ A+' },
        { label: 'Audit pen-test', value: '0 critique' },
        { label: 'Backup · Chiffré', value: 'H-2' },
      ].map((r) => (
        <div key={r.label} style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          padding: '.2rem .4rem',
          background: 'rgba(255,255,255,.03)',
          border: '1px solid rgba(255,255,255,.05)',
          borderRadius: '2px',
        }}>
          <span style={{ fontSize: '.48rem', color: 'rgba(255,255,255,.75)' }}>{r.label}</span>
          <span style={{ fontSize: '.5rem', fontWeight: 700, color: '#4ADE80' }}>{r.value}</span>
        </div>
      ))}
    </div>

    {/* Terminal-ish footer */}
    <div style={{
      background: 'rgba(0,0,0,.3)',
      borderRadius: '2px',
      padding: '.3rem .45rem',
      fontFamily: 'monospace',
      fontSize: '.42rem',
      color: '#4ADE80',
      borderLeft: '2px solid var(--gold)',
    }}>
      $ monitoring --live · 0 alerts · 99.98% uptime
    </div>
  </div>
);

/* ── Mini mockup for featured service (dashboard) ── */
const MiniDashboardMockup: React.FC = () => (
  <div style={{
    background: 'var(--white)',
    border: '1px solid var(--border)',
    borderRadius: '4px',
    padding: '.7rem',
    fontFamily: "'Montserrat', sans-serif",
  }}>
    {/* Tiny header */}
    <div style={{ display: 'flex', gap: '4px', marginBottom: '.5rem' }}>
      <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#FF5F57' }} />
      <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#FEBC2E' }} />
      <div style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#28C840' }} />
      <div style={{ display: 'inline-flex', alignItems: 'center', gap: '.2rem', marginLeft: 'auto' }}>
        <span style={{ width: '5px', height: '5px', borderRadius: '50%', background: '#2E7D32', animation: 'servPulse 1.4s ease-in-out infinite' }} />
        <span style={{ fontSize: '.4rem', fontWeight: 700, color: '#2E7D32', letterSpacing: '.1em' }}>LIVE</span>
      </div>
    </div>
    {/* KPI row */}
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '4px', marginBottom: '.5rem' }}>
      {[
        { v: '€24k', c: 'var(--blue)' },
        { v: '1.2k', c: 'var(--gold)' },
        { v: '+8%', c: '#2E7D32' },
      ].map((k, i) => (
        <div key={i} style={{ background: 'var(--blue-pale)', padding: '.3rem .35rem', borderRadius: '2px' }}>
          <div style={{ fontSize: '.6rem', fontWeight: 700, color: k.c, fontFamily: "'Cormorant Garamond', serif" }}>{k.v}</div>
        </div>
      ))}
    </div>
    {/* Sparkline */}
    <svg viewBox="0 0 120 28" style={{ width: '100%', height: '28px' }}>
      <defs>
        <linearGradient id="servGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="var(--blue)" stopOpacity=".35" />
          <stop offset="100%" stopColor="var(--blue)" stopOpacity="0" />
        </linearGradient>
      </defs>
      <path d="M 0 22 L 15 18 L 30 20 L 45 12 L 60 14 L 75 8 L 90 10 L 105 5 L 120 7 L 120 28 L 0 28 Z" fill="url(#servGrad)" />
      <path d="M 0 22 L 15 18 L 30 20 L 45 12 L 60 14 L 75 8 L 90 10 L 105 5 L 120 7" stroke="var(--blue)" strokeWidth="1.2" fill="none" />
      <circle cx="120" cy="7" r="2" fill="var(--gold)">
        <animate attributeName="r" values="2;3;2" dur="1.4s" repeatCount="indefinite" />
      </circle>
    </svg>
  </div>
);

interface Service {
  num: string;
  Icon: React.FC;
  title: string;
  description: string;
  tags: string[];
  accent: string;
  projectAnchor?: string;
  featured?: boolean;
  medium?: boolean;
  mockup?: React.ReactNode;
}

const services: Service[] = [
  {
    num: '01',
    Icon: IcoDashboard,
    title: 'Dashboards temps réel',
    description: 'Supervision live, KPI WebSocket, alertes et heatmaps pour piloter vos opérations en temps réel.',
    tags: ['WebSocket', 'KPI Live', 'Alertes'],
    accent: 'var(--blue)',
    projectAnchor: '#projets',
    medium: true,
    mockup: <MiniDashboardMockup />,
  },
  {
    num: '02',
    Icon: IcoLink,
    title: 'Intégration CRM & SI',
    description: 'Salesforce, HubSpot, Odoo, SAP: synchronisation bidirectionnelle avec vos systèmes.',
    tags: ['Salesforce', 'Odoo', 'SAP'],
    accent: 'var(--gold-dark)',
    projectAnchor: '#projets',
    medium: true,
    mockup: <MiniCRMMockup />,
  },
  {
    num: '03',
    Icon: IcoCog,
    title: 'Automatisation',
    description: 'Workflows visuels, triggers et RPA pour éliminer les tâches répétitives.',
    tags: ['Workflows', 'RPA', 'n8n'],
    accent: '#2E7D32',
    projectAnchor: '#projets',
    medium: true,
    mockup: <MiniWorkflowMockup />,
  },
  {
    num: '04',
    Icon: IcoAI,
    title: 'IA & LLM',
    description: 'Assistants IA, RAG documentaire et chatbots connectés à vos données.',
    tags: ['LLM', 'RAG', 'Chatbots'],
    accent: '#5E35B1',
    projectAnchor: '#projets',
    medium: true,
    mockup: <MiniAIMockup />,
  },
  {
    num: '05',
    Icon: IcoMobile,
    title: 'Applications Mobile',
    description: 'Apps natives et hybrides iOS/Android, avec auth biométrique, push notifications et sync offline.',
    tags: ['React Native', 'iOS/Android', 'Offline-first'],
    accent: 'var(--blue-dark)',
    projectAnchor: '#projets',
    medium: true,
    mockup: <MiniMobileMockup />,
  },
  {
    num: '06',
    Icon: IcoShield,
    title: 'Cybersécurité & Cloud',
    description: 'Audits, hardening, déploiement cloud sécurisé, monitoring 24/7 et backups chiffrés.',
    tags: ['Cloud', 'Audit', 'DevOps'],
    accent: '#2E7D32',
    medium: true,
    mockup: <MiniCyberMockup />,
  },
];

const ServiceCard: React.FC<{ service: Service; index: number }> = ({ service, index }) => {
  const [hovered, setHovered] = useState(false);
  const { Icon } = service;
  const delay = Math.min(index, 4);

  return (
    <article
      className={`reveal d${delay} serv-card ${service.featured ? 'serv-card-featured' : ''} ${service.medium ? 'serv-card-medium' : ''}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        '--accent': service.accent,
      } as React.CSSProperties}
    >
      {/* Top row: number + icon */}
      <div className="serv-top">
        <div className="serv-num">— {service.num}</div>
        <div className="serv-icon" style={{ borderColor: hovered ? service.accent : 'var(--border)', color: service.accent }}>
          <Icon />
        </div>
      </div>

      <h3 className="serv-title">{service.title}</h3>
      <p className="serv-desc">{service.description}</p>

      {/* Mockup (featured or medium) */}
      {service.mockup && (service.featured || service.medium) && (
        <div className="serv-mockup">{service.mockup}</div>
      )}

      {/* Tags */}
      <div className="serv-tags">
        {service.tags.map((t) => (
          <span key={t} className="serv-tag" style={{ color: service.accent, background: `${service.accent}14` }}>
            {t}
          </span>
        ))}
      </div>

      {/* Link footer */}
      {service.projectAnchor && (
        <a href={service.projectAnchor} className="serv-link" style={{ color: service.accent }}>
          Voir le projet associé
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M1 6h9M6 1l5 5-5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </a>
      )}
    </article>
  );
};

const Enhanced3DServices: React.FC = () => {
  return (
    <section id="services" className="services-section">
      <div className="services-inner">
        <div className="reveal services-header">
          <div className="sec-tag">Expertise</div>
          <h2 className="sec-title">Nos <em>Services</em></h2>
          <div className="gold-bar" />
          <p className="services-intro">
            Quatre piliers d'expertise et deux socles transverses. Des solutions concrètes, pas des promesses.
          </p>
        </div>

        <div className="services-bento">
          {services.map((s, i) => (
            <ServiceCard key={s.num} service={s} index={i} />
          ))}
        </div>
      </div>

      <style>{`
        .services-section {
          padding: 6rem 0;
          background: var(--white);
          position: relative;
        }
        .services-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 2rem;
        }
        .services-header { margin-bottom: 3rem; max-width: 640px; }
        .services-intro {
          font-family: 'Montserrat', sans-serif;
          font-size: .88rem;
          font-weight: 300;
          color: var(--ink2);
          line-height: 1.8;
        }

        /* Bento grid: 1 featured (6 cols) + 3 standard (2 cols each) + 2 small (3 cols each) */
        .services-bento {
          display: grid;
          grid-template-columns: repeat(6, 1fr);
          gap: 1.2rem;
        }
        .serv-card {
          background: var(--blue-pale);
          border: 1px solid var(--border);
          padding: 1.8rem;
          display: flex;
          flex-direction: column;
          gap: .9rem;
          transition: transform .3s ease, background .3s ease, box-shadow .3s ease, border-color .3s ease;
          grid-column: span 2;
          min-width: 0;
          overflow: hidden;
          position: relative;
        }
        .serv-card:hover {
          transform: translateY(-3px);
          background: var(--blue-soft);
          box-shadow: 0 15px 40px -15px rgba(26,111,168,.2);
          border-color: var(--accent);
        }
        .serv-card-featured {
          grid-column: span 6;
          grid-row: span 1;
          background: var(--white);
          border: 1px solid var(--gold);
          padding: 2.2rem;
          position: relative;
        }
        .serv-card-medium {
          grid-column: span 3;
          background: var(--white);
          padding: 1.8rem;
        }
        .serv-card-featured::before {
          content: 'Expertise phare';
          position: absolute;
          top: 1.2rem;
          right: 1.2rem;
          font-family: 'Montserrat', sans-serif;
          font-size: .52rem;
          font-weight: 700;
          letter-spacing: .18em;
          text-transform: uppercase;
          color: var(--gold-dark);
          background: rgba(184,146,42,.12);
          padding: .2rem .55rem;
          border-radius: 2px;
        }
        .serv-top {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
        }
        .serv-num {
          font-family: 'Montserrat', sans-serif;
          font-size: .62rem;
          font-weight: 600;
          color: var(--ink2);
          letter-spacing: .22em;
        }
        .serv-icon {
          width: 44px;
          height: 44px;
          border: 1.5px solid var(--border);
          display: flex;
          align-items: center;
          justify-content: center;
          transition: border-color .25s, background .25s;
          background: var(--white);
        }
        .serv-title {
          font-family: 'Cormorant Garamond', Georgia, serif;
          font-size: 1.4rem;
          font-weight: 600;
          color: var(--ink);
          margin: 0;
          line-height: 1.25;
        }
        .serv-card-featured .serv-title { font-size: 1.9rem; }
        .serv-desc {
          font-family: 'Montserrat', sans-serif;
          font-size: .78rem;
          font-weight: 300;
          color: var(--ink2);
          line-height: 1.75;
          margin: 0;
          flex: 1;
        }
        .serv-card-featured .serv-desc { font-size: .88rem; max-width: 480px; }
        .serv-mockup {
          margin-top: .4rem;
          max-width: 360px;
        }
        .serv-tags {
          display: flex;
          gap: .35rem;
          flex-wrap: wrap;
          margin-top: .3rem;
        }
        .serv-tag {
          font-family: 'Montserrat', sans-serif;
          font-size: .55rem;
          font-weight: 600;
          letter-spacing: .1em;
          text-transform: uppercase;
          padding: .2rem .5rem;
          border-radius: 2px;
        }
        .serv-link {
          display: inline-flex;
          align-items: center;
          gap: .4rem;
          font-family: 'Montserrat', sans-serif;
          font-size: .6rem;
          font-weight: 600;
          letter-spacing: .14em;
          text-transform: uppercase;
          text-decoration: none;
          padding-top: .8rem;
          border-top: 1px solid var(--border);
          margin-top: auto;
          transition: gap .25s;
        }
        .serv-card:hover .serv-link { gap: .7rem; }

        /* Responsive */
        @media (max-width: 1024px) {
          .services-bento { grid-template-columns: repeat(4, 1fr); }
          .serv-card { grid-column: span 2; }
          .serv-card-featured { grid-column: span 4; }
          .serv-card-medium { grid-column: span 2; }
        }
        @media (max-width: 700px) {
          .services-section { padding: 4rem 0; }
          .services-inner { padding: 0 1rem; }
          .services-bento { grid-template-columns: 1fr; gap: 1rem; }
          .serv-card,
          .serv-card-featured,
          .serv-card-medium { grid-column: 1 / -1; padding: 1.3rem; }
          .serv-card-featured .serv-title { font-size: 1.5rem; }
          .serv-title { font-size: 1.15rem; }
        }

        @keyframes servPulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: .4; transform: scale(1.4); }
        }
      `}</style>
    </section>
  );
};

export default Enhanced3DServices;
